// src/components/VisitLanding.tsx
import React from "react";
import { Loader2, ShieldAlert, ShieldCheck } from "lucide-react";
import { Button } from "./ui/button";

interface VisitLandingProps {
  message?: string;
  hint?: string;
  onContinue?: () => void;
}

export function VisitLanding({ message, hint, onContinue }: VisitLandingProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-slate-100 p-6">
      <div className="w-full max-w-xl bg-white border border-slate-200 rounded-2xl shadow-lg p-8 space-y-6">
        <div className="flex items-center justify-center gap-4">
          <img src="/visit-bergamo-logo.svg" alt="Visit Bergamo" className="h-10 w-auto" />
          <span className="text-slate-300">x</span>
          <img src="/travelin-logo.svg" alt="Travelin" className="h-9 w-auto" />
        </div>

        <div className="text-center space-y-2">
          <div className="flex items-center justify-center gap-2 text-slate-800">
            <Loader2 className="w-5 h-5 animate-spin text-blue-600" />
            <p className="text-l font-semibold">Reindirizzamento alla dashboard Gestore Struttura</p>
          </div>
        </div>

        <div className="rounded-2xl border border-blue-100 bg-gradient-to-br from-blue-50 via-white to-slate-50 p-5 text-slate-700 shadow-sm">
          <div className="flex items-start gap-3">
            

            <div className="flex-1 space-y-4">
              <div className="space-y-1">
                <p className="text-sm font-semibold uppercase tracking-[0.12em] text-blue-700">
                  Popup bloccato?
                </p>
                <h3 className="text-base font-semibold text-slate-900">Come consentire l'apertura del popup</h3>
                <p className="text-sm text-slate-600">
                  Se l'accesso non prosegue automaticamente, segui questi passaggi nel browser.
                </p>
              </div>

              <div className="space-y-3">
                {[
                  "Guarda in alto nella barra degli indirizzi: se il popup è stato bloccato, il browser mostra di solito una piccola icona di avviso vicino all’indirizzo del sito.",
                  "Clicca quell’icona: si apre un piccolo menu da cui puoi consentire il popup per questo sito.",
                  "Se non la vedi subito, controlla con attenzione la parte destra della barra degli indirizzi: l’avviso può comparire come icona temporanea o piccolo messaggio del browser.",
                ].map((step, index) => (
                  <div key={index} className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white/80 p-3">
                    <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-900 text-xs font-semibold text-white">
                      {index + 1}
                    </div>
                    <p className="text-sm leading-6 text-slate-700">{step}</p>
                  </div>
                ))}
                <div
                    className={`flex items-start gap-3  p-3 ${
                         " bg-blue-50/80"
                    }`}
                  >
                  
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600">
                      <ShieldAlert className="h-4 w-4 shrink-0" />
            </div>
                    <p className="flex items-start gap-2 text-sm leading-6 text-slate-700">
                      <span className="text-base font-semibold text-slate-900">Dopo aver consentito l'apertura del popup, chiudi questa pagina e riprova l’accesso dal Backoffice di Visit Bergamo.</span>
                    </p>
                  </div>
              </div>

            </div>
          </div>
        </div>

        {onContinue && (
          <div className="flex justify-center">
            <Button variant="outline" onClick={onContinue}>
              Continua al login
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
